import { info } from './index'

// 공통 필터 메서드 적용 
import { checkLimitedUser } from './function/method'

function fetchMainCommonInfo() {
  return info.post('common.do', {searchType: "main"})
  .then((res) => {
    return checkLimitedUser(res)
  });
}

function fetchMiningInfo() {
  return info.post('mining.do', {})
  .then((res) => {
    return checkLimitedUser(res)
  });
}
export { fetchMainCommonInfo, fetchMiningInfo }